export enum UserRole {
  ADMINISTRATOR = 'ADMINISTRATOR',
  EXECUTIVE = 'EXECUTIVE',
  MEMBER = 'MEMBER',
  MEMBER_LIMITED_PHI = 'MEMBER_LIMITED_PHI',
}
